import { render, staticRenderFns } from "./ValidationToggle.vue?vue&type=template&id=a54f379a&scoped=true&"
import script from "./ValidationToggle.vue?vue&type=script&lang=js&"
export * from "./ValidationToggle.vue?vue&type=script&lang=js&"
import style0 from "./ValidationToggle.vue?vue&type=style&index=0&id=a54f379a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54f379a",
  null
  
)

export default component.exports